/** Share of observed queries, not of 50: the API total can exceed 50 on retries. */
export function sharePercent(count: number, total: number): number {
    if (!total) return 0
    return (count / total) * 100
}

export function formatPercent(value: number, digits = 1): string {
    return `${value.toFixed(digits)}%`
}

export function formatLatency(ms: number | undefined): string {
    if (ms === undefined || !Number.isFinite(ms)) return '—'
    return `${Math.round(ms)} ms`
}

/** Distances are approximate by nature; showing metres would be false precision. */
export function formatDistance(km: number | undefined): string {
    if (km === undefined || !Number.isFinite(km)) return '—'
    if (km < 1) return '<1 km'
    if (km < 1000) return `${Math.round(km)} km`
    return `${(km / 1000).toFixed(1)}k km`
}

/** Keeps the head and tail, which is where dns names and hex tokens differ. */
export function ellipsis(value: string, max: number): string {
    if (value.length <= max) return value
    const tail = Math.min(8, Math.floor(max / 3))
    return `${value.slice(0, max - tail - 1)}…${value.slice(-tail)}`
}

export function formatAsn(asn: number | undefined): string {
    return asn === undefined ? '—' : `AS${asn}`
}

/** Absolute, short, and locale-aware. Saved tests are days or weeks old, so a
    relative "3 weeks ago" is less useful than the date itself. */
export function formatDate(ms: number): string {
    return new Date(ms).toLocaleString(undefined, {
        year: 'numeric', month: 'short', day: 'numeric',
        hour: '2-digit', minute: '2-digit',
    })
}
